import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[680px] flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Warm%20abstract%20artistic%20composition%20with%20overlapping%20geometric%20shapes%20in%20amber%20gold%20terracotta%20and%20cream%20tones%2C%20soft%20gradients%2C%20modern%20minimal%20design%2C%20smooth%20textures%2C%20elegant%20harmonious%20warm%20colors%2C%20no%20blue%20or%20purple%20hues%2C%20professional%20editorial%20quality&width=1600&height=900&seq=hero-bg-main&orientation=landscape')`,
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/50"></div>

      <div className="relative z-10 w-full container-custom text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight max-w-4xl mx-auto">
          发现真实，<strong className="text-primary-400">揭露真相</strong>
        </h1>
        <p className="mt-4 md:mt-6 text-sm md:text-lg text-background-200/90 max-w-2xl mx-auto leading-relaxed">
          黑料社区致力于打造一个开放、真实的信息分享平台。在这里，你可以浏览社会热点、行业揭秘、娱乐八卦等多元内容，参与社区讨论，了解事件背后的真相。
        </p>
        <div className="mt-8 md:mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/zuixin-baoliao"
            className="px-8 py-3 bg-primary-500 text-background-50 rounded-md text-sm md:text-base font-medium hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            立即浏览内容
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 border border-background-50/40 text-background-50 rounded-md text-sm md:text-base font-medium hover:bg-background-50/10 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            了解社区
          </Link>
        </div>
        <div className="mt-10 md:mt-14 flex items-center justify-center gap-8 text-background-200/70 text-xs md:text-sm">
          <div className="flex items-center gap-2">
            <span className="font-bold text-lg md:text-2xl text-background-50">10万+</span>
            <span>注册用户</span>
          </div>
          <div className="w-px h-8 bg-background-50/20"></div>
          <div className="flex items-center gap-2">
            <span className="font-bold text-lg md:text-2xl text-background-50">1000+</span>
            <span>独家内容</span>
          </div>
          <div className="w-px h-8 bg-background-50/20"></div>
          <div className="flex items-center gap-2">
            <span className="font-bold text-lg md:text-2xl text-background-50">50万+</span>
            <span>月活跃用户</span>
          </div>
        </div>
      </div>
    </section>
  );
}